export default __webpack_public_path__ + "static/media/UTENTE_questionario-2.5dec1cd7.png";